import { render, staticRenderFns } from "./ReviewPlan.vue?vue&type=template&id=cdbe89a2&"
import script from "./ReviewPlan.vue?vue&type=script&lang=js&"
export * from "./ReviewPlan.vue?vue&type=script&lang=js&"
import style0 from "./ReviewPlan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ReviewPlan.vue"
export default component.exports